
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Strip HTML tags from a string and decode HTML entities
 * @param value - The string that may contain HTML tags
 * @returns Clean text without HTML tags
 */
export function stripHtmlTags(value: string | null | undefined): string {
  if (!value) return '';
  // Convert <br> tags to newlines before stripping
  return value
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&[^;]+;/g, ' ')
    .trim();
}

/**
 * Scroll to an element with ID with smooth behavior
 * @param elementId - The ID of the element to scroll to
 * @param offset - Optional offset from the top (default: -80)
 */
export function scrollToElement(elementId: string, offset: number = -80) {
  const element = document.getElementById(elementId);
  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }
  return false;
}
